enum InputType {
  Default = 'DEFAULT',
  Search = 'SEARCH',
  Password = 'PASSWORD',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Date = 'DATE',
  Textarea = 'TEXTAREA',
  Checkbox = 'CHECKBOX',
}
export default InputType;
